import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { useUserOrganization } from '@/hooks/useUserOrganization'

export interface OrderTemplate {
  order_template_id: number
  name: string
}

export function useOrderTemplates() {
  const { data: membership } = useUserOrganization()
  const orgId = membership?.organization_id

  return useQuery({
    queryKey: ['order-templates', orgId],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('erp')
        .from('order_templates')
        .select('order_template_id, name')
        .eq('organization_id', orgId!)
        .order('name')

      if (error) throw error
      return (data || []) as OrderTemplate[]
    },
    enabled: !!orgId,
    staleTime: 5 * 60_000,
  })
}
